var _path, _ellipse, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCouponAwarded = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#BCD9C9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.7141,
    cy: 25.0001,
    rx: 15.8571,
    ry: 17.1429,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.0001,
    r: 17.25,
    stroke: "#727D79",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1278 24.8179V19.3053C26.6945 19.549 27.9214 20.6785 27.9214 21.9902C27.9214 22.3525 28.1625 22.6454 28.4607 22.6454C28.7589 22.6454 29 22.3525 29 21.9902C29 19.9513 27.312 18.2649 25.1278 17.9884V16.6551C25.1278 16.2935 24.8867 15.9999 24.5884 15.9999C24.2902 15.9999 24.0491 16.2935 24.0491 16.6551V17.9655C21.7786 18.1692 20 19.8969 20 21.9902C20 23.1937 20.5452 25.2628 24.0491 25.9396V31.4227C22.3988 31.2399 21.0786 30.0763 21.0786 28.7162C21.0786 28.3539 20.8375 28.061 20.5393 28.061C20.2411 28.061 20 28.3539 20 28.7162C20 30.8095 21.7786 32.5365 24.0491 32.7409V34.3448C24.0491 34.7071 24.2902 34.9999 24.5884 34.9999C24.8867 34.9999 25.1278 34.7071 25.1278 34.3448V32.718C27.312 32.4421 29 30.7557 29 28.7168C29 27.5401 28.4758 25.5288 25.1278 24.8179ZM21.0786 21.9908C21.0786 20.6307 22.3988 19.4665 24.0491 19.2837V24.6174C22.5919 24.3095 21.0786 23.6032 21.0786 21.9908ZM25.1278 31.4011V26.1492C26.3908 26.4506 27.9214 27.1392 27.9214 28.7168C27.9214 30.0285 26.6945 31.158 25.1278 31.4011Z",
    fill: "#FF8B22",
    stroke: "#FF8B22",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCouponAwarded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-coupon-awarded.3f2e36549e731f67aac4ccc8f8f1635d.svg";